import React from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import {Col} from "reactstrap";
require("highcharts/modules/networkgraph")(Highcharts);

const NetworkCharts = (props) => {
    const width = window.innerWidth
    const height = window.innerHeight
    const options = {


        chart: {
            type: 'networkgraph',
            height:500,
            plotBackgroundColor: "transparent",
            plotBorderWidth: null,
            plotShadow: false,
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft:0,
            spacingRight: 0,
            padding:100,
            style: {
                fontFamily: 'iranyekan',
                fontWeight:"600",
                fontSize: '1.2em',
                color: "rgba(255,255,255,0.33)",
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip:{
            formatter:function(){
                var info="";
                return "<b>"+this.key + "</b> "+info;
            }
        },


        plotOptions: {
            networkgraph: {
                size: '70%',
                allowPointSelect: true,
                cursor: 'pointer',
                keys: ['from', 'to'],
                layoutAlgorithm: {
                    enableSimulation: true,
                    integration: 'verlet',
                    linkLength: 200
                },
                point: {

                    events: {
                        click: function(arr,event) {
                            if(props.ClickHandler!==undefined){
                                props.ClickHandler(arr.point.catId)
                            }
                        }
                    }
                },
            }
        },

        series: [{
            marker: {
                radius: 13,
            },
            dataLabels: {
                enabled: true,
                linkFormat: '',
                allowOverlap: true,style: {
                    textOutline: false
                }
            },
            data:props.data.data,
            nodes: props.data.nodes,
        }]

    }
    return (
      <Col sm={12}>
          <HighchartsReact
              data={props.data}
              options={options}
              allowChartUpdate={ false }
              constructorType={"chart"}
              highcharts ={Highcharts}

          />
      </Col>
    );
}

export default NetworkCharts;